// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"444":"d5465d5fa28c4f22","641":"194028cc52827b02"}[chunkId] + ".js";
};